@if (ready) {
  <h1 class="pb-4">{{ content.signUpHeadline }}</h1>
  <form [formGroup]="signUpForm">
    <div class="form-group">
      <label class="sr-only" for="signupFirstName">First Name</label>
      <input type="text" class="form-control" id="signupFirstName" placeholder="First Name"
        formControlName="firstName" required>
      @if (formService.controlHasError( signUpForm.get('firstName'), 'required')) {
        <div
          class="form-control-feedback">First Name is required
        </div>
      }
    </div>
    <div class="form-group">
      <label class="sr-only" for="signupEmail">Email</label>
      <input type="email" class="form-control" id="signupEmail" placeholder="Email"
        formControlName="email" required>
      @if (formService.controlHasError( signUpForm.get('email'), 'required')) {
        <div
          class="form-control-feedback">Email is required
        </div>
      }
      @if (formService.controlHasError( signUpForm.get('email'), 'email')) {
        <div
          class="form-control-feedback">Not valid email
        </div>
      }
    </div>
    <div class="form-group">
      <label class="sr-only" for="signupPassword">
      Password</label>
      <input type="password" class="form-control" id="signupPassword" placeholder="Password"
        formControlName="password" required>
      @if (formService.controlHasError( signUpForm.get('password'), 'required')) {
        <div
          class="form-control-feedback">Password is required
        </div>
      }
    </div>
    <div class="form-group">
      <label class="sr-only" for="signupPhoneNumber">Phone Number</label>
      <app-phone-input
        inputId="signupPhoneNumber"
        formControlName="phoneNumber">
      </app-phone-input>
      @if (formService.controlHasError( signUpForm.get('phoneNumber'), 'required')) {
        <div
          class="form-control-feedback">Phone number is required
        </div>
      }
      @if (formService.controlHasError( signUpForm.get('phoneNumber'), 'phoneNumber')) {
        <div
          class="form-control-feedback">Enter a valid phone number
        </div>
      }
    </div>
    <a class="btn btn-block btn-primary" (click)="submitForm()">Sign Up</a>
    <div class="mt-4 text-center">
      <a [routerLink]="'/login'">Already have an account? Log In</a>
    </div>
  </form>
} @else {
  <div class="center-div">
    <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
  </div>
}

<app-feedback></app-feedback>

